import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import StaffManagementCard from "./StaffManagementCard";
import { getStaffList } from "../Actions/StaffManagementAPI";
import { normalizeShipStaffRecord } from "../helpers/shipStaffNormalize";
import "./UserManagementMaster.css";

const PAGE_SIZE = 15;
const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const defaultSearchData = {
  Name: "",
  PageNumber: 1,
  PageSize: PAGE_SIZE,
};

class StaffManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: { ...defaultSearchData },
      loading: false,
    };
    this.SearchStaff = this.SearchStaff.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.viewClick = this.viewClick.bind(this);
    this.editClick = this.editClick.bind(this);
    this.deleteStaff = this.deleteStaff.bind(this);
    this.handleAddStaff = this.handleAddStaff.bind(this);
  }

  componentDidMount() {
    const { dispatch, staffSearch, t } = this.props;
    const searchData = staffSearch || { ...defaultSearchData };

    this.setState({ searchData }, () => {
      dispatch(getStaffList(this.state.searchData));
    });

    dispatch({
      type: "SubBannerTitle",
      data: t("StaffManagementScreenContent.Title").toUpperCase(),
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.showSidePane !== prevProps.showSidePane && !this.props.showSidePane) {
      this.props.dispatch(getStaffList(this.state.searchData));
    }
  }

  SearchStaff(pageNumber) {
    const { dispatch } = this.props;
    const searchData = {
      ...this.state.searchData,
      PageNumber: pageNumber || 1,
    };

    this.setState({ searchData, loading: true });
    dispatch({ type: "staffSearch", data: searchData });
    dispatch(getStaffList(searchData));
    this.setState({ loading: false });
  }

  handleInputChange(e) {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      searchData: {
        ...prevState.searchData,
        [name]: value,
      },
    }));
  }

  ClearInput() {
    const { dispatch } = this.props;
    this.setState({ searchData: { ...defaultSearchData } });
    dispatch({ type: "staffSearch", data: "" });
    dispatch(getStaffList(defaultSearchData));
  }

  viewClick(id, item) {
    const { dispatch, history } = this.props;
    const staff = normalizeShipStaffRecord(item);
    dispatch({ type: "StaffDetails", data: staff });
    dispatch({ type: "ShowSidePan", data: true });
    history.push(`/Home/Management/Staff/${id}`);
    window.scrollTo(0, 0);
  }

  editClick(id, item) {
    const { dispatch, history } = this.props;
    if (item) {
      dispatch({ type: "StaffDetails", data: normalizeShipStaffRecord(item) });
    }
    dispatch({ type: "ShowSidePan", data: false });
    history.push(`/Home/Management/Staff/Edit/${id}`);
    window.scrollTo(0, 0);
  }

  deleteStaff(item) {
    const { t, dispatch } = this.props;
    const staff = normalizeShipStaffRecord(item);

    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const payload = {
              shipStaffId: staff.shipStaffId,
              name: staff.name,
              phone: staff.phone,
              email: staff.email,
              address: staff.address || "",
              isDeleted: true,
              modifiedBy: currentUser?.name || "",
              modifiedDate: "",
            };

            axios
              .put(API.putShipStaff, payload, {
                headers: { key: currentUser.accessToken },
              })
              .then(() => {
                dispatch(getStaffList(this.state.searchData));
                dispatch({ type: "ShowSidePan", data: false });
                toast.success(t("CommonText.CommonDelete"));
              })
              .catch(() => {
                toast.error(t("CommonText.500ErrorMessage"));
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
        },
      ],
    });
  }

  handleAddStaff() {
    const { dispatch, history } = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    dispatch({ type: "StaffDetails", data: "" });
    history.push("/Home/Management/Staff/Add");
    window.scrollTo(0, 0);
  }

  render() {
    const { StaffInfoList, showSidePane, t } = this.props;
    const { loading } = this.state;
    const staffList = (StaffInfoList?.data || []).map(normalizeShipStaffRecord);
    const pagination = StaffInfoList?.pagination || {
      totalcount: 0,
      pageSize: PAGE_SIZE,
      currentPage: 1,
    };

    return (
      <div className="full-height user-module-master">
        <div className="pt-3">
          <div className="row">
            <div className="col-12">
              <div className="um-section">
                <div className="um-section-header">
                  <h5 className="um-section-title">
                    <i className="fa fa-filter um-section-title-icon" aria-hidden="true"></i>
                    {t("StaffManagementScreenContent.SearchFilters")}
                  </h5>
                </div>
                <div className="um-section-body">
                  <div className="um-filter-bar um-filter-bar-single">
                    <div className="um-filter-bar-fields">
                      <div className="um-filter-field">
                        <label className="form-label">
                          {t("EquipmentManagementScreenContent.Name")}
                        </label>
                        <div className="um-input-shell">
                          <span className="um-input-icon">
                            <i className="fa fa-user" aria-hidden="true"></i>
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="Name"
                            placeholder={t("EquipmentManagementScreenContent.Name")}
                            value={this.state.searchData.Name}
                            onChange={this.handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="um-filter-bar-actions">
                      <button
                        className="btn btn-primary text-uppercase um-btn um-btn-primary"
                        type="button"
                        onClick={() => this.SearchStaff(1)}
                        disabled={loading}
                      >
                        {t("content.Search")}
                      </button>
                      <button
                        className="btn btn-light text-uppercase um-btn um-btn-secondary"
                        type="button"
                        onClick={this.ClearInput}
                        disabled={loading}
                      >
                        {t("content.Clear")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="um-section">
                <div className="um-section-header">
                  <h5 className="um-section-title">
                    <i className="fa fa-users um-section-title-icon" aria-hidden="true"></i>
                    {t("StaffManagementScreenContent.Title")}
                  </h5>
                  <button
                    type="button"
                    className="um-header-add-btn"
                    onClick={this.handleAddStaff}
                  >
                    <i className="fa fa-plus" aria-hidden="true"></i>
                    <span>{t("ShipManagementContent.Add")}</span>
                  </button>
                </div>
                <div className="um-list-body">
                  <StaffManagementCard
                    currentPage={pagination.currentPage || 1}
                    arraylist={staffList}
                    pageSize={pagination.pageSize || PAGE_SIZE}
                    totalRecords={pagination.totalcount || 0}
                    setUpdatedState={(value) => this.SearchStaff(value)}
                    viewClick={(id, item) => this.viewClick(id, item)}
                    editClick={(id, item) => this.editClick(id, item)}
                    deleteStaff={(item) => this.deleteStaff(item)}
                    showSidePane={showSidePane}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    StaffInfoList: state.SidePanReducer.StaffList,
    staffSearch: state.SidePanReducer.staffSearch,
  };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(StaffManagement))
);
